module.exports = __webpack_public_path__ + "img/chat-attachment-files-two.0c70451d.svg";